import { createFileRoute } from '@tanstack/react-router'
import { APP_NAME } from '@/lib/utils'
import Announcements from '@/features/announces'

export const Route = createFileRoute('/_authenticated/announces/')({
  component: Announcements,
  head: () => ({
    meta: [
      {
        title: `${APP_NAME} | Announcements`,
      },
    ],
  }),
  // beforeLoad: async () => {
  //   try {
  //     const res = await getCurrentUser()
  //     if (!res?.id) {
  //       throw redirect({
  //         to: '/sign-in-2',
  //       })
  //     }
  //   } catch (_) {
  //     throw redirect({
  //       to: '/sign-in-2',
  //     })
  //   }
  // },
})
